<template>
  <div>
    <BlockTitle
      :title="t('СМИ о нас', options)"
      class="mb-8"
    />
    <CoreSwiper>
      <template #slides="{ slideAttrs, swiperInstance }">
        <div
          v-for="newsItem in news"
          :key="newsItem.id"
          class="border rounded-sm text-center py-4"
          v-bind="slideAttrs"
        >
          <MassMediaSlide
            :news-item="newsItem"
            :swiper-instance="swiperInstance"
          />
        </div>
      </template>
    </CoreSwiper>
  </div>
</template>

<script setup lang="ts">
import CoreSwiper from 'src/core/CoreSwiper/CoreSwiper.vue'
import I18NextVue from 'i18next'
import { News } from 'src/components/pages/info/pressa/types'
import BlockTitle from 'src/components/pages/info/pressa/components/BlockTitle.vue'
import MassMediaSlide from 'src/components/pages/info/pressa/components/mobile/MassMediaSlide.vue'

const { t, language } = I18NextVue
const options = { ns: language }

defineProps<{
  news: News[]
}>()
</script>

<style scoped lang="scss">
.swiper-slide,
.swiper-slide * {
  box-sizing: border-box;
}
</style>
